



























import { List, ListItem, StepperInput } from "@goodless/components"
import { Session } from "@goodless/networking";
import { Cart, Product } from "@goodless/structures";
import { Formatter } from "@goodless/utilities";
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
    components: {
        List,
        ListItem,
        StepperInput
    },
})
export default class CartItems extends Mixins(NavigationMixin) {
    @Prop({ required: true })
    cart: Cart

    @Prop({ default: false })
    editable: boolean

    @Prop({ default: null })
    updateCart: (() => void) | null

    get isLoggedIn() {
        return Session.shared.isComplete() && Session.shared.hasToken()
    }

    formatPrice(price: number) {
        return Formatter.price(price)
    }

    removeItem(item, index) {
        this.cart.removeItem(item, index)
        if (this.updateCart) {
            this.updateCart()
        }
    }

    getProductSrc(product: Product) {
        return product.images[0]?.getPathForSize(200, 200) ?? ""
    }
}
